// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"c17b4066","544":"c17b4066","578":"b0ade8fe","778":"bb865a11","824":"b354c7c0","825":"34601be7","920":"c17b4066"}[chunkId] + ".chunk.css";
};